import GameManager from '../../../../core/GameManager';
import BleedingControlScenario, { ScenarioEndType, ScenarioSceneType, StepToSkip } from '../../../../misc/BleedingControlScenario';
import { constants, ILaunchedScenario, launchedScenarioStore } from '../../../../misc/helpers';
import mainPracticeScenarioStep1 from './MainPracticeScenarioStep1';
import mainPracticeScenarioStep2 from './MainPracticeScenarioStep2';
import mainPracticeScenarioSteps12 from './MainPracticeScenarioSteps12';
import mainPracticeScenarioSteps13And14And15 from './MainPracticeScenarioSteps13And14And15';
import mainPracticeScenarioSteps3And4 from './MainPracticeScenarioSteps3And4';
import mainPracticeScenarioSteps5And6 from './MainPracticeScenarioSteps5And6';
import mainPracticeScenarioSteps7And8 from './MainPracticeScenarioSteps7And8';
import mainPracticeScenarioSteps9And10And11 from './MainPracticeScenarioSteps9And10And11';
import mainPracticeScenarioEnd from './MainPracticeScenarioEnd';
import { customRouter } from '../../../../CustomRouter';

export default class MainPracticeScenario extends BleedingControlScenario {
	constructor(gameManager: GameManager, scenarioName: string, public scenarioSceneToLoad: ScenarioSceneType, 
		public endAt: ScenarioEndType, stepsToSkip?: StepToSkip[], isSufficient?: boolean, shownPercentage?: number,shownPercentage2?:number, locations?: any[], locations2?: any[], correctT1?: number, correctT2?: number, wrongT1?: number, closeT1?: number, 
		SceneAT?: boolean, SceneBT?: boolean, SceneCT?: boolean, SceneDT?: boolean, startTitle?: string, startTitleText?: string) {
		super(gameManager, scenarioName, scenarioSceneToLoad, endAt, stepsToSkip, isSufficient, shownPercentage, shownPercentage2);
		this.locations = locations;
		this.locations2 = locations2;
		this.correctT1 = correctT1;
		this.correctT2 = correctT2;
		this.wrongT1 = wrongT1;
		this.closeT1 = closeT1;
		this.SceneAT = SceneAT;
		this.SceneBT = SceneBT;
		this.SceneCT = SceneCT;
		this.SceneDT = SceneDT;
		this.startTitle = startTitle;
		this.startTitleText = startTitleText;

	}
	
	public locations: any = [];
	public locations2: any = [];
	public correctT1: number;
	public correctT2: number;
	public wrongT1: number;
	public closeT1: number;
	public SceneAT: boolean;
	public SceneBT: boolean;
	public SceneCT: boolean;
	public SceneDT: boolean;
	public startTitle: string = '';
	public startTitleText: string = '';

	public soundFolderAndPath(section: string, part: string): string {
		throw new Error('soundFolderAndPath needs to be implemented in child class')
	}
	public selectedTourniquetIndex = 0;
	public moveToTourniquetLocation() {
		this.playSequence('TorniqueteLocation' + this.selectedTourniquetIndex);
	}
	start() {
		this.goToStep0();
	}

	goToStep0() {
		var context = this;
		switch (this.scenarioSceneToLoad) {
			case ScenarioSceneType.scenarioA:
				context.loadParkingGarageScene('scenarioa', () => context.goToStep1());
				break;
			case ScenarioSceneType.scenarioB:
				context.loadOutsideVAScene('scenariob', () => context.goToStep1());
				break;
			case ScenarioSceneType.scenarioC:
				context.loadLobbyVAScene('scenarioc', () => context.goToStep1());
				break;
			case ScenarioSceneType.scenarioD:
				context.loadOutsideVAScene('scenariod', () => context.goToStep1());
				break;

		}
	}

	goToStep1() {
		var context = this;
		new mainPracticeScenarioStep1(this, () => context.goToStep2(), () => context.goToFailedScenario(), context.startTitle, context.startTitleText).start();
	}

	goToStep2() {
		var context = this;
		new mainPracticeScenarioStep2(this, () => {
			if (this.stepsToSkip && this.stepsToSkip.indexOf(StepToSkip.steps3And4And5And6) !== -1) {
				context.goToSteps7And8();
			} else {
				context.goToSteps3And4();
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps3And4() {
		var context = this;
		new mainPracticeScenarioSteps3And4(this, () => { context.goToSteps5And6(); }, () => context.goToFailedScenario()).start();
	}

	goToSteps5And6() {
		var context = this;
		new mainPracticeScenarioSteps5And6(this, () => { 
			if(this.endAt === ScenarioEndType.pressureDressing) {
				context.goToScenarioEnd();
			} else {
				context.goToSteps7And8(); 
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps7And8() {
		var context = this;
		new mainPracticeScenarioSteps7And8(this, () => { context.goToSteps9And10And11(); }, () => context.goToFailedScenario()).start();
	}

	goToSteps9And10And11() {
		var context = this;
		new mainPracticeScenarioSteps9And10And11(this, () => { 
			if(this.endAt === ScenarioEndType.firstTourniquete) {
				context.goToScenarioEnd();
			} else {
				context.goToSteps12(); 
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps12() {
		var context = this;
		new mainPracticeScenarioSteps12(this, () => { context.goToSteps13And14And15(); }, () => context.goToFailedScenario()).start();
	}

	goToSteps13And14And15() {
		var context = this;
		new mainPracticeScenarioSteps13And14And15(this, () => { context.goToScenarioEnd(); }, () => context.goToFailedScenario()).start();
	}

	goToScenarioEnd() {
		var context = this;
		this.aarPassed = true;
		new mainPracticeScenarioEnd(this, () => { 
			//TODO: go back to main menu
			context.setScenarioPassed(true);
			context.endScenario();
		}).start();
	}

	goToFailedScenario() {
		var context = this;
		this.aarPassed = false;
		new mainPracticeScenarioEnd(this, () => { 
			context.setScenarioPassed(false);
			context.endScenario();
		}).start();
	}

	public showMainMenu() {
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		
		search_params.set('w', '0');

		url.search = search_params.toString();

		window.location.href = url.toString();
		//window.location.href = process.env.PUBLIC_URL
	}

}